import { render } from "./NimpStock.vue?vue&type=template&id=fbbebb4e&scoped=true"
import script from "./NimpStock.vue?vue&type=script&lang=js"
export * from "./NimpStock.vue?vue&type=script&lang=js"

import "./NimpStock.vue?vue&type=style&index=0&id=fbbebb4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbbebb4e"]])

export default __exports__